import { render, staticRenderFns } from "./DocumentFacts.vue?vue&type=template&id=0972774e&"
import script from "./DocumentFacts.vue?vue&type=script&lang=js&"
export * from "./DocumentFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports